/*
 * File: PatientCard.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/02/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the top of the chart details
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import References from "services/references/References";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";

const styles = theme => ({
  itemContainer: {
    flexDirection: "row"
  },
  patientData: {
    marginTop: theme.spacing(2),
    color: theme.palette.common.label
  },
  patientIdBirth: {
    color: theme.palette.common.label
  },
  patientName: {
    fontWeight: 500
  }
});

const PatientCard = ({ classes, patient, providerModel }) => {
  const references = useStore(References);

  /**
   * Returns a name reference by id for phoneTypes
   *
   * @param {Number} type
   * @return {String}
   */
  const findPhoneName = type => {
    const typeString = String(type);
    const obj = references.getPhoneTypes().find(r => r.id === typeString);
    if (obj) {
      return obj.name;
    }
    return "";
  };

  /**
   * Returns a name reference by id for sex
   *
   * @param {Number} type
   * @return {String}
   */
  const findSexName = type => {
    const typeString = String(type);
    const obj = references.getSexTypes().find(r => r.id === typeString);
    if (obj) {
      return obj.name;
    }
    return "";
  };

  if (patient?.patientId === undefined) {
    // Instead of showing broken UI when no patient has loaded, just display a blank space.
    return null;
  }

  const phoneType = patient.phone1
    ? findPhoneName(patient.phone1.type)
    : "Home Phone";
  const phoneNumber = patient.phone1 ? patient.phone1.number : "";
  return (
    <div className={classes.itemContainer}>
      <Typography variant="h6" className={classes.patientName}>
        {patient.fullName}
      </Typography>
      <div className={classes.patientIdBirth}>
        <Typography variant="body1">
          <b>Patient ID:</b> {patient.displayId}
        </Typography>
        <Typography variant="body1">
          <b>Birth Date:</b> {patient.birthDayString()}
        </Typography>
      </div>
      <div className={classes.patientData}>
        <Typography variant="body1">
          <b>Account Provider:</b> {providerModel.accountProvider.fullName}
        </Typography>
        <Typography variant="body1">
          <b>Office:</b> {providerModel.patientOffice.name}
        </Typography>
        <Typography variant="body1">
          <b>Sex:</b> {findSexName(patient.sex)}
        </Typography>
        <Typography variant="body1">
          <b>{phoneType}:</b> {phoneNumber}
        </Typography>
        <Typography variant="body1">
          <b>Email:</b> {patient.email}
        </Typography>{" "}
      </div>
    </div>
  );
};

PatientCard.propTypes = {
  classes: PropTypes.object,
  patient: PropTypes.object,
  providerModel: PropTypes.object.isRequired
};

export default observer(withStyles(styles)(PatientCard));
